// import React, { useState, useEffect } from 'react';
// import { AppBar, Toolbar, Box, Avatar, Typography, IconButton, Menu, MenuItem, ListItemIcon, ListItemText } from '@mui/material';
// import { useNavigate, useLocation } from 'react-router-dom';
// import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
// import PersonIcon from '@mui/icons-material/Person';
// import LogoutIcon from '@mui/icons-material/Logout';
// import logo from '../../assets/Logo.png';
// import { getInitials, getAvatarColor } from '../../utils/avatarUtils';
// import API_BASE_URL from '../../config/api';

// const Navbar = ({ toggleSidebar }) => {
//   const navigate = useNavigate();
//   const location = useLocation();
//   const fullName = localStorage.getItem("fullName") || "User";
//   const [anchorEl, setAnchorEl] = useState(null);
//   const [profilePhoto, setProfilePhoto] = useState(null);
//   const open = Boolean(anchorEl);
  
//   const initials = getInitials(fullName);
//   const avatarColor = getAvatarColor(fullName);

//   // Fetch profile photo
//   useEffect(() => {
//     const fetchProfilePhoto = async () => {
//       try {
//         const token = localStorage.getItem("token");
//         if (!token) return;

//         const response = await fetch(`${API_BASE_URL}/api/profile`, {
//           headers: { Authorization: `Bearer ${token}` },
//         });

//         if (response.ok) {
//           const data = await response.json();
//           setProfilePhoto(data.profile?.photo || null);
//         }
//       } catch (error) {
//         console.error("Error fetching profile photo:", error);
//       }
//     };

//     fetchProfilePhoto();

//     // Listen for profile photo updates
//     const handlePhotoUpdate = () => {
//       fetchProfilePhoto();
//     };

//     window.addEventListener('profilePhotoUpdated', handlePhotoUpdate);

//     return () => {
//       window.removeEventListener('profilePhotoUpdated', handlePhotoUpdate);
//     };
//   }, [location.pathname]); // Refetch when route changes

//   const handleMenuOpen = (event) => {
//     setAnchorEl(event.currentTarget);
//   };

//   const handleMenuClose = () => {
//     setAnchorEl(null);
//   };

//   const handleProfile = () => {
//     handleMenuClose();
//     navigate("/profile");
//   };

//   const handleLogout = () => {
//     handleMenuClose();
//     localStorage.removeItem("token");
//     localStorage.removeItem("role");
//     localStorage.removeItem("fullName");
//     navigate("/login");
//   };

//   return (
//     <AppBar
//       position="fixed"
//       elevation={0}
//       sx={{
//         background: 'transparent',
//         boxShadow: 'none',
//         color: 'inherit',
//         backdropFilter: 'blur(6px)',
//         borderBottom: '1px solid #BC965E',
//         zIndex: (theme) => theme.zIndex.drawer + 1,
//       }}
//     >
//       <Toolbar
//         sx={{
//           display: 'flex',
//           justifyContent: 'space-between',
//           alignItems: 'center',
//         }}
//       >
//         {/* Left: Logo */}
//         <Box
//           component="a"
//           href="/dashboard"
//           sx={{
//             display: 'flex',
//             alignItems: 'center',
//             textDecoration: 'none',
//             marginLeft: 0,
//           }}
//         >
//           <img src={logo} alt="logo" style={{ height: 38 }} />
//         </Box>

//         {/* Right: User info with dropdown */}
//         <Box
//           sx={{
//             display: 'flex',
//             alignItems: 'center',
//             gap: 1,
//           }}
//         >
//           <Typography sx={{ display: { xs: 'none', sm: 'block' } }}>
//             {fullName}
//           </Typography>
//           <Avatar 
//             alt={fullName}
//             src={profilePhoto ? `${API_BASE_URL}${profilePhoto}` : undefined}
//             sx={{ 
//               bgcolor: profilePhoto ? 'transparent' : avatarColor,
//               fontWeight: 600,
//               fontSize: '1rem',
//               border: '2px solid #BC965E'
//             }}
//           >
//             {!profilePhoto && initials}
//           </Avatar>
//           <IconButton
//             onClick={handleMenuOpen}
//             size="small"
//             sx={{ color: '#BC965E' }}
//           >
//             <ArrowDropDownIcon />
//           </IconButton>
          
//           <Menu
//             anchorEl={anchorEl}
//             open={open}
//             onClose={handleMenuClose}
//             anchorOrigin={{
//               vertical: 'bottom',
//               horizontal: 'right',
//             }}
//             transformOrigin={{
//               vertical: 'top',
//               horizontal: 'right',
//             }}
//             PaperProps={{
//               sx: {
//                 mt: 1,
//                 minWidth: 180,
//                 boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
//               }
//             }}
//           >
//             <MenuItem onClick={handleProfile}>
//               <ListItemIcon>
//                 <PersonIcon fontSize="small" sx={{ color: '#BC965E' }} />
//               </ListItemIcon>
//               <ListItemText>Profile</ListItemText>
//             </MenuItem>
//             <MenuItem onClick={handleLogout}>
//               <ListItemIcon>
//                 <LogoutIcon fontSize="small" color="error" />
//               </ListItemIcon>
//               <ListItemText>Logout</ListItemText>
//             </MenuItem>
//           </Menu>
//         </Box>
//       </Toolbar>
//     </AppBar>
//   );
// };

// export default Navbar;








// import React, { useState, useEffect } from 'react';
// import {
//   AppBar,
//   Toolbar,
//   Box,
//   Avatar,
//   Typography,
//   IconButton,
//   Menu,
//   MenuItem,
//   ListItemIcon,
//   ListItemText,
//   useMediaQuery,
// } from '@mui/material';
// import { useTheme } from '@mui/material/styles';
// import { useNavigate, useLocation } from 'react-router-dom';
// import MenuIcon from '@mui/icons-material/Menu';
// import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
// import PersonIcon from '@mui/icons-material/Person';
// import LogoutIcon from '@mui/icons-material/Logout';
// import logo from '../../assets/Logo.png';
// import { getInitials, getAvatarColor } from '../../utils/avatarUtils';
// import API_BASE_URL from '../../config/api';

// const Navbar = ({ toggleSidebar }) => {
//   const navigate = useNavigate();
//   const location = useLocation();

//   const fullName = localStorage.getItem('fullName') || 'User';

//   const [anchorEl, setAnchorEl] = useState(null);
//   const [profilePhoto, setProfilePhoto] = useState(null);

//   const open = Boolean(anchorEl);

//   const initials = getInitials(fullName);
//   const avatarColor = getAvatarColor(fullName);

//   const theme = useTheme();
//   const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

//   // Fetch profile photo (UNCHANGED)
//   useEffect(() => {
//     const fetchProfilePhoto = async () => {
//       try {
//         const token = localStorage.getItem('token');
//         if (!token) return;

//         const response = await fetch(`${API_BASE_URL}/api/profile`, {
//           headers: { Authorization: `Bearer ${token}` },
//         });

//         if (response.ok) {
//           const data = await response.json();
//           setProfilePhoto(data.profile?.photo || null);
//         }
//       } catch (error) {
//         console.error('Error fetching profile photo:', error);
//       }
//     };

//     fetchProfilePhoto();

//     const handlePhotoUpdate = () => {
//       fetchProfilePhoto();
//     };

//     window.addEventListener('profilePhotoUpdated', handlePhotoUpdate);

//     return () => {
//       window.removeEventListener('profilePhotoUpdated', handlePhotoUpdate);
//     };
//   }, [location.pathname]);

//   const handleMenuOpen = (event) => {
//     setAnchorEl(event.currentTarget);
//   };

//   const handleMenuClose = () => {
//     setAnchorEl(null);
//   };

//   const handleProfile = () => {
//     handleMenuClose();
//     navigate('/profile');
//   };

//   const handleLogout = () => {
//     handleMenuClose();
//     localStorage.removeItem('token');
//     localStorage.removeItem('role');
//     localStorage.removeItem('fullName');
//     navigate('/login');
//   };

//   return (
//     <AppBar
//       elevation={0}
//       sx={{
//         background: 'linear-gradient(90deg, #1a1a1a 0%, #2d2d2d 100%)',
//         boxShadow: '0 2px 8px rgba(0,0,0,0.3)',
//         zIndex: (theme) => theme.zIndex.drawer + 1,
//         height: 80,
//         justifyContent: 'center',
//         borderBottom: '1px solid rgba(196, 165, 116, 0.3)',
//       }}
//     >
//       <Toolbar
//         sx={{
//           display: 'flex',
//           justifyContent: 'space-between',
//           alignItems: 'center',
//           minHeight: 80,
//         }}
//       >
//         {/* Mobile Menu */}
//         {isMobile && (
//           <IconButton
//             onClick={toggleSidebar}
//             sx={{ color: '#C4A574', mr: 2 }}
//           >
//             <MenuIcon />
//           </IconButton>
//         )}

//         {/* Logo */}
//         <Box
//           component="a"
//           href="/dashboard"
//           sx={{ display: 'flex', alignItems: 'center', textDecoration: 'none' }}
//         >
//           <img src={logo} alt="logo" style={{ height: 50 }} />
//         </Box>

//         {/* User Section */}
//         <Box
//           sx={{
//             display: 'flex',
//             alignItems: 'center',
//             gap: 1.5,
//             cursor: 'pointer',
//           }}
//         >
//           <Typography
//             sx={{
//               display: { xs: 'none', sm: 'block' },
//               color: '#fff',
//               fontWeight: 500,
//             }}
//           >
//             {fullName}
//           </Typography>

//           <Avatar
//             alt={fullName}
//             src={profilePhoto ? `${API_BASE_URL}${profilePhoto}` : undefined}
//             sx={{
//               bgcolor: profilePhoto ? 'transparent' : avatarColor,
//               color: '#000',
//               fontWeight: 700,
//               width: 40,
//               height: 40,
//               border: '2px solid #C4A574',
//             }}
//           >
//             {!profilePhoto && initials}
//           </Avatar>

//           <IconButton onClick={handleMenuOpen} sx={{ color: '#C4A574' }}>
//             <ArrowDropDownIcon />
//           </IconButton>
//         </Box>

//         {/* Dropdown Menu */}
//         <Menu
//           anchorEl={anchorEl}
//           open={open}
//           onClose={handleMenuClose}
//           anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
//           transformOrigin={{ vertical: 'top', horizontal: 'right' }}
//           PaperProps={{
//             sx: {
//               mt: 1,
//               minWidth: 180,
//               bgcolor: '#2d2d2d',
//               color: '#fff',
//               boxShadow: '0 4px 12px rgba(0,0,0,0.4)',
//               '& .MuiMenuItem-root:hover': {
//                 bgcolor: 'rgba(196, 165, 116, 0.2)',
//               },
//             },
//           }}
//         >
//           <MenuItem onClick={handleProfile}>
//             <ListItemIcon>
//               <PersonIcon sx={{ color: '#C4A574' }} fontSize="small" />
//             </ListItemIcon>
//             <ListItemText>Profile</ListItemText>
//           </MenuItem>

//           <MenuItem onClick={handleLogout}>
//             <ListItemIcon>
//               <LogoutIcon color="error" fontSize="small" />
//             </ListItemIcon>
//             <ListItemText>Logout</ListItemText>
//           </MenuItem>
//         </Menu>
//       </Toolbar>
//     </AppBar>
//   );
// };

// export default Navbar;









// ...existing code...
import React, { useState, useEffect } from 'react';
import {
  AppBar,
  Toolbar,
  Box,
  Avatar,
  Typography,
  IconButton,
  Menu,
  MenuItem,
  ListItemIcon,
  ListItemText,
  useMediaQuery,
} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { useNavigate, useLocation } from 'react-router-dom';
import MenuIcon from '@mui/icons-material/Menu';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import PersonIcon from '@mui/icons-material/Person';
import LogoutIcon from '@mui/icons-material/Logout';
import logo from '../../assets/Logo.png';
import { getInitials, getAvatarColor } from '../../utils/avatarUtils';
import API_BASE_URL from '../../config/api';

const Navbar = ({ toggleSidebar }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const fullName = localStorage.getItem('fullName') || 'User';

  const [anchorEl, setAnchorEl] = useState(null);
  const [profilePhoto, setProfilePhoto] = useState(null);

  const open = Boolean(anchorEl);

  const initials = getInitials(fullName);
  const avatarColor = getAvatarColor(fullName);

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  // Fetch profile photo (UNCHANGED)
  useEffect(() => {
    const fetchProfilePhoto = async () => {
      try {
        const token = localStorage.getItem('token');
        if (!token) return;

        const response = await fetch(`${API_BASE_URL}/api/profile`, {
          headers: { Authorization: `Bearer ${token}` },
        });

        if (response.ok) {
          const data = await response.json();
          setProfilePhoto(data.profile?.photo || null);
        }
      } catch (error) {
        console.error('Error fetching profile photo:', error);
      }
    };

    fetchProfilePhoto();

    const handlePhotoUpdate = () => {
      fetchProfilePhoto();
    };

    window.addEventListener('profilePhotoUpdated', handlePhotoUpdate);

    return () => {
      window.removeEventListener('profilePhotoUpdated', handlePhotoUpdate);
    };
  }, [location.pathname]);

  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleProfile = () => {
    handleMenuClose();
    navigate('/profile');
  };

  const handleLogout = () => {
    handleMenuClose();
    localStorage.removeItem('token');
    localStorage.removeItem('role');
    localStorage.removeItem('fullName');
    localStorage.removeItem('staffType');
    navigate('/login');
  };

  // If parent passed toggleSidebar, use it; otherwise dispatch a global event
  const handleToggleSidebar = () => {
    if (typeof toggleSidebar === 'function') {
      toggleSidebar();
    } else {
      window.dispatchEvent(new Event('toggleSidebar'));
    }
  };

  return (
    <AppBar
      elevation={0}
      sx={{
        background: 'linear-gradient(90deg, #1a1a1a 0%, #2d2d2d 100%)',
        boxShadow: '0 2px 8px rgba(0,0,0,0.3)',
        zIndex: (theme) => theme.zIndex.drawer + 1,
        height: 80,
        justifyContent: 'center',
        borderBottom: '1px solid rgba(196, 165, 116, 0.3)',
      }}
    >
      <Toolbar
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          minHeight: 80,
        }}
      >
        {isMobile && (
          <IconButton
            onClick={handleToggleSidebar}
            sx={{ color: '#C4A574', mr: 2 }}
            aria-label="open sidebar"
          >
            <MenuIcon />
          </IconButton>
        )}

        {/* hide logo on mobile where hamburger is present */}
        <Box
          component="a"
          href="/dashboard"
          sx={{
            display: { xs: 'none', md: 'flex' },
            alignItems: 'center',
            textDecoration: 'none',
          }}
        >
          <img src={logo} alt="logo" style={{ height: 50 }} />
        </Box>

        {/* User Section */}
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 1.5,
            cursor: 'pointer',
          }}
          onClick={handleMenuOpen}
        >
          <Typography
            sx={{
              display: { xs: 'none', sm: 'block' },
              color: '#fff',
              fontWeight: 500,
            }}
          >
            {fullName}
          </Typography>

          <Avatar
            alt={fullName}
            src={profilePhoto ? `${API_BASE_URL}${profilePhoto}` : undefined}
            sx={{
              bgcolor: profilePhoto ? 'transparent' : avatarColor,
              color: '#000',
              fontWeight: 700,
              width: 40,
              height: 40,
              border: '2px solid #C4A574',
            }}
          >
            {!profilePhoto && initials}
          </Avatar>

          <IconButton onClick={handleMenuOpen} sx={{ color: '#C4A574' }}>
            <ArrowDropDownIcon />
          </IconButton>
        </Box>

        {/* Dropdown Menu */}
        <Menu
          anchorEl={anchorEl}
          open={open}
          onClose={handleMenuClose}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
          transformOrigin={{ vertical: 'top', horizontal: 'right' }}
          PaperProps={{
            sx: {
              mt: 1,
              minWidth: 180,
              bgcolor: '#2d2d2d',
              color: '#fff',
              boxShadow: '0 4px 12px rgba(0,0,0,0.4)',
              '& .MuiMenuItem-root:hover': {
                bgcolor: 'rgba(196, 165, 116, 0.2)',
              },
            },
          }}
        >
          <MenuItem onClick={handleProfile}>
            <ListItemIcon>
              <PersonIcon sx={{ color: '#C4A574' }} fontSize="small" />
            </ListItemIcon>
            <ListItemText>Profile</ListItemText>
          </MenuItem>

          <MenuItem onClick={handleLogout}>
            <ListItemIcon>
              <LogoutIcon color="error" fontSize="small" />
            </ListItemIcon>
            <ListItemText>Logout</ListItemText>
          </MenuItem>
        </Menu>
      </Toolbar>
    </AppBar>
  );
};

export default Navbar;
// ...existing code...

